import React, { useEffect, useState } from "react"
import { useTranslation } from "next-i18next"
import tw, { styled } from "twin.macro"
import { ReactComponent as RefreshApp } from "../../assets/icons/refresh-app.svg"
import { Modal } from "../modal"

const Main = styled.div(() => [tw`flex flex-col items-center justify-center h-full w-72 m-20`])
const Title = styled.div(() => [tw`text-xl mt-8 mb-3 font-bold`])
const Button = styled.button(() => [tw`h-14 w-full my-8 bg-purple rounded text-white font-bold`])

const RefreshAppModal = () => {
  const { t } = useTranslation("newAppAvailable")
  return (
    <Main>
      <RefreshApp />
      <Title>{t("title")}</Title>
      <span>{t("text")}</span>
      <Button onClick={() => window.location.reload()}>{t("button")}</Button>
    </Main>
  )
}

const NewAppAvailable = () => {
  const [showModal, setShowModal] = useState(false)
  const modalProps = { show: showModal, setShow: setShowModal, component: <RefreshAppModal />, notDismissable: true }

  useEffect(() => setShowModal(true), [])

  return <Modal {...modalProps} />
}
export default NewAppAvailable
